import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { getPageMetadata, SITE_ORIGIN } from "../../seo/metadata";

function updateElement(selector, tag, attributes) {
  const matches = [...document.head.querySelectorAll(selector)];
  const element = matches.shift() || document.createElement(tag);
  matches.forEach((duplicate) => duplicate.remove());
  Object.entries(attributes).forEach(([name, value]) => element.setAttribute(name, value));
  if (!element.parentNode) document.head.appendChild(element);
  return element;
}

export default function SeoMetadata({ title, description, canonicalPath, noindex = false }) {
  const { pathname, search } = useLocation();
  const page = getPageMetadata(pathname, search);
  const pageTitle = title || page.title;
  const pageDescription = description || page.description;
  const canonical = `${SITE_ORIGIN}${canonicalPath || page.canonicalPath}`;

  useLayoutEffect(() => {
    document.head.querySelectorAll("title").forEach((node) => node.remove());
    const titleElement = document.createElement("title");
    titleElement.textContent = pageTitle;
    document.head.appendChild(titleElement);
    const elements = [
      titleElement,
      updateElement('meta[name="description"]', "meta", { name: "description", content: pageDescription }),
      updateElement('meta[name="robots"]', "meta", { name: "robots", content: noindex ? "noindex, follow" : "index, follow" }),
      updateElement('link[rel="canonical"]', "link", { rel: "canonical", href: canonical }),
      updateElement('meta[property="og:title"]', "meta", { property: "og:title", content: pageTitle }),
      updateElement('meta[property="og:description"]', "meta", { property: "og:description", content: pageDescription }),
      updateElement('meta[property="og:url"]', "meta", { property: "og:url", content: canonical }),
      updateElement('meta[property="og:type"]', "meta", { property: "og:type", content: "website" }),
    ];
    return () => elements.forEach((element) => element.remove());
  }, [pageTitle, pageDescription, canonical, noindex]);

  return null;
}
